import React, { useState } from "react";
import RequestService from "../../../services/request.service";

// import { Button, Modal, ToggleButton, ButtonGroup } from 'react-bootstrap'
// import { Form, Col, Row } from 'react-bootstrap'
import { Modal, Form } from 'react-bootstrap'

import { Formik } from 'formik';
import * as yup from 'yup';


import { toast } from 'react-toastify'



import './reporte_mensual.scss';


import { confirm } from '../../../widgets/confirm'


// import moment from 'moment'
// import 'moment/locale/es';






const ConfigurarMetasSucursales = ( props ) =>{


  const { fecha_reporte, showModalMetas , handleClose, uuid_sucursal } = props

  // const [ metas, setMetas ] = useState<any>({})

  // const cargarMetas = async (fecha_reporte:string) =>{
  //   try{
  //     let response = await RequestService.getEndPoint('modal/configuracion_metas/'+uuid_sucursal+'/'+fecha_reporte)
  //     setMetas(response.data)
  //   }
  //   catch(e){
  //     toast.error('Error cargando las metas de este mes')
  //   }
  // }



const schema = yup.object().shape({
          iddepartamento: yup.number().required('El departamento es un campo obligatorio'),
          // folio: yup.string(),
          folios_meta: yup.number().required('Debes ingresar una cantidad o 0'),
          monto_meta: yup.number().required('Debes ingresar una cantidad o 0'),
          // fecha_tramite: yup.date().required(),
        })



      return (



          <>

      <Modal 
                size="lg"
                // onEnter={()=>{cargarMetas(fecha_reporte)}}
                
                backdrop="static"

      show={showModalMetas} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Configuración de Metas Mensuales</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          

    <Formik
      validationSchema={schema}
      onSubmit={ async (values : any, { setSubmitting }) => {
        try{

            if (await confirm({
              confirmation: '¿Estás seguro?'
            })) {
                console.table(values);
              }
        }
        catch(e){
           toast.error('Pushale, error...');  
         }

      }}
      initialValues={{

          iddepartamento : '',
          folios_meta : "",
          monto_meta : "",
          // monto : (Math.floor(Math.random() * 40000) + 1),
          // fecha_tramite : moment().format('YYYY-MM-DD'),
          // folio : "GMEF-2022-"+(Math.random().toString(36).substr(2,6).split("").map(e=>Math.random()<Math.random()?e.toUpperCase():e).join().replaceAll(",","")).toUpperCase(),

      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        isValid,
        errors,
      }) => (

        <Form noValidate onSubmit={handleSubmit}>

            <div className="row">
              <div className="col-4">

                  
                    <Form.Group className="mb-3">
                      <Form.Label>Folio</Form.Label>
                      <Form.Control
                        type="text"
                        name="folios_meta"
                        value={values.folios_meta}
                        onChange={handleChange}
                        isValid={touched.folios_meta && !errors.folios_meta}
                        isInvalid={!!errors.folios_meta}
                      />
                        <Form.Control.Feedback type="invalid">
                          {errors.folios_meta}
                        </Form.Control.Feedback>
                    </Form.Group>


                  
                    <Form.Group className="mb-3">
                      <Form.Label>Monto</Form.Label>
                      <Form.Control
                        type="text"
                        name="monto_meta"
                        value={values.monto_meta}
                        onChange={handleChange}
                        isValid={touched.monto_meta && !errors.monto_meta}
                        isInvalid={!!errors.monto_meta}
                      />
                        <Form.Control.Feedback type="invalid">
                          {errors.monto_meta}
                        </Form.Control.Feedback>
                    </Form.Group>


                  {
                    // JSON.stringify(metas.DepartamentosPorConfigurar)
                  }
              </div>
              <div className="col-8">


<table className="table">
  <thead>
    <tr>
      <th scope="col">Departamento</th>
      <th scope="col">Monto</th>
      <th scope="col">Folio</th>
    </tr>
  </thead>
  <tbody>

    {




    }

    <tr>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
</table>


                  {
                    // JSON.stringify(metas.MetasDepartamentos)
                  }
              </div>
            </div>



       </Form>


      )}

    </Formik>




            {uuid_sucursal}
            <br />



        </Modal.Body>
      </Modal>
              
          </>

      );
  

}

export default ConfigurarMetasSucursales